<ion-content>
  <div class="csoport-besorolas-page">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Tanulók besorolása csoportba</ion-card-title>
        <ion-card-subtitle>
          Egy tanuló továbbra is egy osztályhoz tartozik, de itt több független csoportba is besorolható.
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <div class="toolbar">
          <ion-button
            fill="outline"
            color="primary"
            class="csoport-valaszto-gomb"
            (click)="csoportPickerNyitas()"
          >
            <ion-icon slot="start" name="search-outline"></ion-icon>
            <ng-container *ngIf="kivalasztottCsoport; else nincsCsoport">
              {{ kivalasztottCsoport.name }}
              <ng-container *ngIf="kivalasztottCsoport.ev">&nbsp;({{ kivalasztottCsoport.ev }})</ng-container>
            </ng-container>
            <ng-template #nincsCsoport>Válassz csoportot…</ng-template>
          </ion-button>

          <ion-input
            label="Keresés"
            label-placement="stacked"
            fill="outline"
            placeholder="Név, oktatási azonosító vagy osztály"
            [(ngModel)]="kereses"
            (ionInput)="szures()"
          ></ion-input>

          <ion-toggle [(ngModel)]="csakTagok" (ionChange)="szures()">Csak csoporttagok</ion-toggle>
          <!--  Az óra nélküli csoport vagy még nem került be az órarendbe, vagy
                fölöslegesen jött létre – ezeket kell átnézni.  -->
          <ion-toggle [(ngModel)]="csakOraNelkuli">Csak az óra nélküli csoportok</ion-toggle>
          <!--  Az üres csoportnak se névsora, se órája: ott a törlés nem vesz el semmit.  -->
          <ion-toggle [(ngModel)]="csakUres">Csak az üres csoportok (se óra, se névsor)</ion-toggle>

          <!--  Takarítás egy menetben. Csak akkor kínáljuk, ha a felhasználó épp az óra
                nélkülieket nézi – így nem lehet véletlenül az egész listát letörölni.  -->
          <ion-button *ngIf="csakOraNelkuli" fill="outline" color="danger"
                      [disabled]="tomegesTorles || !oraNelkuliCsoportok.length"
                      (click)="oraNelkuliTorles()"
                      title="Az óra nélküli csoportok törlése egy menetben – a névsoros és más adathoz kötött csoportokat külön kérdezzük">
            <ion-icon slot="start" name="trash-outline"></ion-icon>
            Óra nélküliek törlése ({{ oraNelkuliCsoportok.length }})
          </ion-button>

          <ion-button *ngIf="csakUres" fill="outline" color="danger"
                      [disabled]="tomegesTorles || !uresCsoportok.length"
                      (click)="uresTorles()"
                      title="A se órával, se névsorral nem rendelkező csoportok törlése egy menetben">
            <ion-icon slot="start" name="trash-outline"></ion-icon>
            Üresek törlése ({{ uresCsoportok.length }})
          </ion-button>

          <!-- Nyomtatható jelenléti ív a kiválasztott csoport névsorával. -->
          <ion-button fill="outline" color="medium" (click)="jelenletiIv()"
                      [disabled]="!kivalasztottCsoport"
                      title="Jelenléti ív a csoport névsorával, aláírás-rovattal">
            <ion-icon slot="start" name="print-outline"></ion-icon>
            Jelenléti ív
          </ion-button>

          <ion-button fill="outline" color="primary" (click)="ujCsoportForm = !ujCsoportForm">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>
            Új csoport
          </ion-button>
        </div>

        <div class="uj-csoport-form" *ngIf="ujCsoportForm">
          <ion-input label="Csoport neve" label-placement="stacked" fill="outline"
            placeholder="pl. Angol 1. csoport" [(ngModel)]="ujCsoport.name"></ion-input>
          <ion-input label="Tanév (kezdő év)" label-placement="stacked" fill="outline" type="number"
            [(ngModel)]="ujCsoport.ev"></ion-input>
          <ion-select label="Foglalkozás típusa" label-placement="stacked" fill="outline" interface="popover"
                      [(ngModel)]="ujCsoport.foglalkozas_tipus" (ionChange)="ujCsoportTipusValt()">
            <ion-select-option *ngFor="let t of foglalkozasTipusok" [value]="t.ertek">{{ t.nev }}</ion-select-option>
          </ion-select>
          <ion-toggle [(ngModel)]="ujCsoport.hianyzas_szamit">A csoport óráin számítson a hiányzás</ion-toggle>
          <ion-toggle *ngIf="!ujCsoport.hianyzas_szamit" [(ngModel)]="ujCsoport.opcionalis_reszvetel">
            Opcionális részvétel (csak jelenlét, nincs hiányzás)
          </ion-toggle>
          <ion-button color="success" (click)="csoportLetrehozas()" [disabled]="csoportLetrehozasFolyamatban">
            <ion-icon slot="start" name="save-outline"></ion-icon>
            Létrehozás
          </ion-button>
        </div>

        <div class="group-settings" *ngIf="kivalasztottCsoport">
          <!-- Átnevezés: a csoportra mindenhol az azonosító hivatkozik, ezért a
               besorolások, az órarend és a tantárgyfelosztás megmarad. -->
          <div class="atnevezes">
            <ion-input label="Csoport neve" label-placement="stacked" fill="outline"
                       [(ngModel)]="ujNev" placeholder="pl. Angol 1. csoport"></ion-input>
            <ion-button size="small" color="primary" (click)="csoportAtnevezes()"
                        [disabled]="nevMentes || !ujNev || ujNev === kivalasztottCsoport.name">
              <ion-icon slot="start" name="create-outline"></ion-icon>Átnevezés
            </ion-button>
            <ion-button size="small" fill="clear" color="danger" (click)="csoportTorles()">
              <ion-icon slot="start" name="trash-outline"></ion-icon>Csoport törlése
            </ion-button>
            <ion-note color="medium">
              A tanulói besorolás, az órarend és a tantárgyfelosztás megmarad – csak a megjelenő név változik.
              Törölni csak üres csoportot lehet (nincs benne tanuló, óra és tantárgyfelosztás).
            </ion-note>
          </div>

          <!-- A FOGLALKOZÁS TÍPUSA: csoportnapló (tanórai) vagy egyéb foglalkozási napló (szakkör,
               sportkör, napközi, tanulószoba, egyéb) – 20/2012. EMMI r. 102–103. §. A hiányzás
               számítását nem állítja át. -->
          <ion-select class="fogl-tipus" label="Foglalkozás típusa" label-placement="stacked" fill="outline" interface="popover"
                      [(ngModel)]="kivalasztottCsoport.foglalkozas_tipus" (ionChange)="foglalkozasTipusMentes()">
            <ion-select-option *ngFor="let t of foglalkozasTipusok" [value]="t.ertek">{{ t.nev }}</ion-select-option>
          </ion-select>
          <ion-note color="medium">
            A tanórai csoportról csoportnapló, a szakkörről, sportkörről, napköziről, tanulószobáról és más egyéb
            foglalkozásról egyéb foglalkozási napló készül (Adatkinyerések › Kötelező nyomtatványok), és a haladási naplóban
            jelölve látszik. Automatikusnál a hiányzás-kapcsoló dönt: ha a hiányzás nem számít, egyéb foglalkozás.
          </ion-note>
          <ion-note color="warning" *ngIf="tipusEltero">{{ tipusEltero }}</ion-note>

          <ion-toggle
            [(ngModel)]="kivalasztottCsoport.hianyzas_szamit"
            (ionChange)="hianyzasKapcsolo()"
          >
            A csoport óráin számítson a hiányzás
          </ion-toggle>
          <ion-note color="medium">
            Kapcsold ki szakköri, adminisztratív vagy nem tanórai célú csoportoknál.
          </ion-note>

          <ion-toggle
            *ngIf="!kivalasztottCsoport.hianyzas_szamit"
            [(ngModel)]="kivalasztottCsoport.opcionalis_reszvetel"
            (ionChange)="hianyzasKapcsolo()"
          >
            Opcionális részvétel
          </ion-toggle>
          <ion-note color="medium" *ngIf="!kivalasztottCsoport.hianyzas_szamit">
            Bekapcsolva minden tag jelenléti státusza üres; csak azt jelölöd, ki volt jelen. Nincs hiányzás,
            és nincsenek tanórai gombok (dicséret, felszereléshiány stb.).
          </ion-note>

          <ion-item lines="none" class="tantargy-valaszto">
            <ion-label position="stacked">A csoport tantárgyai (jegybeírás, gyermek jegyei, tanmenet)</ion-label>
            <ion-select
              [(ngModel)]="kivalasztottTantargyIds"
              [multiple]="true"
              placeholder="Válassz tantárgya(ka)t"
              (ionChange)="tantargyakMentese()"
            >
              <ion-select-option *ngFor="let t of osszesTantargy" [value]="t.id">
                {{ t.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </div>

        <div class="actions" *ngIf="kivalasztottCsoport">
          <ion-button color="primary" fill="outline" (click)="osszesLathatoKijelolese(true)">
            Láthatók kijelölése
          </ion-button>
          <ion-button color="medium" fill="outline" (click)="osszesLathatoKijelolese(false)">
            Láthatók törlése
          </ion-button>
          <ion-button color="success" (click)="mentesInditasa()" [disabled]="mentes">
            <ion-icon slot="start" name="save-outline"></ion-icon>
            Mentés ({{ kijeloltDb }})
          </ion-button>
        </div>

        <!--  A VÁLTOZÁS NAPJA: a felvett tanuló a belépés napjától tag, a kivett tanuló
              tagsága a kilépés napja előtti nappal zárul – a korábbi névsor megmarad. -->
        <div class="valtozas-datumok" *ngIf="kivalasztottCsoport && (felvendoDb || kiveendoDb)">
          <ion-input *ngIf="felvendoDb" type="date" fill="outline" label-placement="stacked"
                     [label]="'Belépés napja (' + felvendoDb + ' felvett tanuló)'"
                     [min]="tanevHatar?.min || '1900-01-01'" [max]="tanevHatar?.max || '9999-12-31'"
                     [(ngModel)]="belepesNapja"></ion-input>
          <ion-input *ngIf="kiveendoDb" type="date" fill="outline" label-placement="stacked"
                     [label]="'Kilépés napja (' + kiveendoDb + ' kivett tanuló)'"
                     [min]="tanevHatar?.min || '1900-01-01'" [max]="tanevHatar?.max || '9999-12-31'"
                     [(ngModel)]="kilepesNapja"></ion-input>
          <ion-note color="medium">
            A felvett tanuló a belépés napjától tagja a csoportnak; a kivett tanuló a kilépés napjától
            már nem tag (az utolsó napja az előző nap). A korábbi névsor és a hozzá tartozó adatok megmaradnak.
            <ng-container *ngIf="tanevHatar"> A dátum a csoport tanévén belül lehet ({{ tanevHatar.min }} – {{ tanevHatar.max }}).</ng-container>
          </ion-note>
        </div>

        <ion-progress-bar type="indeterminate" *ngIf="betoltes"></ion-progress-bar>

        <div class="empty-state" *ngIf="!betoltes && !kivalasztottCsoport">
          Válassz egy csoportot a tanulók besorolásához.
        </div>

        <div class="student-list" *ngIf="kivalasztottCsoport">
          <ion-item class="student-row" *ngFor="let tanulo of szurtTanulok">
            <ion-checkbox slot="start" [(ngModel)]="tanulo.selected"></ion-checkbox>
            <ion-label>
              <h2>{{ tanulo.full_name || 'Névtelen tanuló' }}</h2>
              <p>
                {{ tanulo.oktazon }}
                <ng-container *ngIf="tanulo.aktualis_osztaly"> · {{ tanulo.aktualis_osztaly }}</ng-container>
                <ng-container *ngIf="tanulo.csoportban && tanulo.tagsag_kezdete"> · tag {{ tanulo.tagsag_kezdete }}-tól</ng-container>
                <ng-container *ngIf="tanulo.csoportban && tanulo.tagsag_vege"> · utolsó nap: {{ tanulo.tagsag_vege }}</ng-container>
              </p>
            </ion-label>
            <ion-button slot="end" size="small" fill="outline" (click)="zaradekokMegnyitasa(tanulo)">
              <ion-icon slot="start" name="document-text-outline"></ion-icon>
              Záradékok
            </ion-button>
          </ion-item>

          <div class="empty-state" *ngIf="!betoltes && szurtTanulok.length === 0">
            Nincs a szűrésnek megfelelő tanuló.
          </div>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
